import React from 'react';

const MarketSelectionHeaders = ({ selectedMarkets }) => (
  <tr className="tr--primary">
    {selectedMarkets.map(market => {
      if (!market || market.selections === undefined) {
        return null;
      }

      return (
        <th key={market.id}>
          <div className="table-f">
            {market.selections.map((selection) => (
              <div key={selection.id}>{selection.name}</div>
            ))}
          </div>
        </th>
      );
    })}
  </tr>
);

export default MarketSelectionHeaders;
